<h3 mat-dialog-title>Atividade</h3>
<div mat-dialog-content>

    <div fxLayout="column wrap">
        <div fxFlex.gt-sm="100%">
            <strong>Data:</strong> {{ data.dados.data_hora_atividade | date:'dd/MM/yyyy HH:mm:ss' }}
        </div>
        <div fxFlex.gt-sm="100%" *ngIf="data.dados.atividade_clientes.length > 0">
            <strong>Cliente:</strong> {{ data.dados.atividade_clientes[0].cliente.nome }}
        </div> 
        <div fxFlex.gt-sm="100%">
            <strong>Assunto:</strong> {{data.dados.assunto.nome}}
        </div>        
        <div fxFlex.gt-sm="100%">
            <strong>Observação:</strong> {{data.dados.observacao}}
        </div>
    </div>
</div>
<br>
<div mat-dialog-actions>
    <button
        mat-button
        tabindex="2"
        (click)="onNoClick()">
        Fechar
    </button>
</div>